import Vue from 'vue'
import Vuex from 'vuex'
import { Workspaces, Workspace, Template, Ref, RepoCollection, WorkspaceJson, WorkspaceContentJson, DashboardWidget, EntityContainer, Reply, ReplyCode, Entity, Context, Configurations, ExternalFile, BlobContent} from "../model";
import { Account, BalanceSheet, Counterparty, Currency, TransactionType, Register, Transaction, uuid } from "../model"
import { templateList } from "../model"
import { saveAs } from 'file-saver';

import {
  CREATE_WORKSPACE,
  GET_WORKSPACES,
  GET_CURRENT_WORKSPACE,
  GET_TEMPLATE_LIST,
  SET_REPO_COLLECTION,
  GET_TRANSACTIONS,
  GET_ACCOUNTS,
  GET_COUNTERPARITES,
  GET_TRANSACTION_TYPES,
  GET_CURRENCIES,
  GET_PRIMARY_CURRENCY,
  SAVE_TRANSACTION,
  DELETE_TRANSACTION,
  SAVE_ACCOUNT,
  SAVE_COUNTERPARTY,
  SAVE_TRANSACTION_TYPE,
  SAVE_CURRENCY,
  SET_CURRENT_WORKSPACE,
  BEGIN_UPLOAD,
  END_UPLOAD,
  ERROR,
  CLEAR_ERROR,
  GET_DASHBOARD_WIDGETS,
  SAVE_DASHBOARD_WIDGET,
  EDIT_DASHBOARD_WIDGET,
  DELETE_DASHBOARD_WIDGET,
  DELETE_ACCOUNT,
  GET_CONFIGURATIONS,
  DELETE_COUNTERPARTY,
  DELETE_TRANSACTION_TYPE,
  DELETE_CURRENCY,
  GET_DEFAULT_COUNTERPARTY,
} from "./mutation-types"

Vue.use(Vuex)

const state:()=>State = () => ({
  workspaces: [],
  currentWorkspace : undefined,
  repoCollection : undefined,
  templateList: [],

  configurations: undefined,
  transactions: [],
  counterparties: [],
  accounts: [],
  transactionTypes: [],
  currencies: [],
  primaryCurrency: undefined,
  defaultCounterparty: undefined,
  dashboardWidgets:[],
 
  uploadInProgress: false,
  actionError : false,
  actionErrorMsg : "",
});

interface State {
  workspaces:Workspace[];
  currentWorkspace:Workspace | undefined;
  repoCollection:RepoCollection | undefined;
  templateList:Template[];

  configurations: Configurations | undefined;
  transactions:Transaction[];
  accounts:Account[];
  transactionTypes:TransactionType[];
  counterparties:Counterparty[];
  currencies:Currency[];
  primaryCurrency:Currency | undefined;
  defaultCounterparty:Counterparty | undefined;
  dashboardWidgets:DashboardWidget[];
  
  uploadInProgress:boolean;
  actionError:boolean;
  actionErrorMsg:string;
}

interface StateCommit{
  commit:any,
  state:State
}

function addToList<E extends Entity<E>>(list: E[], item:E) {
  deleteFromList(list, item);
  list.push(item);
}

function deleteFromList<E extends Entity<E>>(list: E[], item: E) {
  let index = list.findIndex(a => a.uuid === item.uuid);
  if (index > -1) {
    list.splice(index, 1);
  }
}

const mutations = {
  [GET_CONFIGURATIONS](state:State, configurations:Configurations) {
    state.configurations = configurations;
  },
  [GET_TRANSACTIONS](state:State, transactions:Transaction[]) {
    const txs = [...transactions];
    state.transactions = txs;
  },
  [GET_ACCOUNTS](state:State, accounts:Account[]) {
    state.accounts = Account.sort([...accounts]);
  },
  [GET_COUNTERPARITES](state:State, counterparties:Counterparty[]) {
    state.counterparties = [...counterparties];
  },
  [GET_DEFAULT_COUNTERPARTY](state:State, counterparty:Counterparty) {
    state.defaultCounterparty = counterparty;
  },
  [GET_TRANSACTION_TYPES](state:State, transactionTypes:TransactionType[]) {
    state.transactionTypes = [...transactionTypes];
  },
  [GET_CURRENCIES](state:State, currencies:Currency[]) {
    state.currencies = [...currencies];
  },
  [GET_PRIMARY_CURRENCY](state:State, currency:Currency) {
    state.primaryCurrency = currency;
  },
  [SAVE_TRANSACTION](state:State, transaction:Transaction) {
    addToList(state.transactions, transaction);
  },
  [SAVE_ACCOUNT](state:State, account:Account) {
    addToList(state.accounts, account);
  },
  [SAVE_TRANSACTION_TYPE](state:State, transactionType:TransactionType) {
    addToList(state.transactionTypes, transactionType);
  },
  [SAVE_COUNTERPARTY](state:State, counterparty:Counterparty) {
    addToList(state.counterparties, counterparty);
  },
  [SAVE_CURRENCY](state:State, currency:Currency) {
    addToList(state.currencies, currency);
  },
  [DELETE_TRANSACTION](state:State, transaction:Transaction) {
    deleteFromList(state.transactions, transaction);
  },
  [DELETE_ACCOUNT](state:State, account:Account) {
    deleteFromList(state.accounts, account);
  },
  [DELETE_COUNTERPARTY](state:State, counterparty:Counterparty) {
    deleteFromList(state.counterparties, counterparty);
  },  
  [DELETE_TRANSACTION_TYPE](state:State, transactionType:TransactionType) {
    deleteFromList(state.transactionTypes, transactionType);
  },
  [DELETE_CURRENCY](state:State, currency:Currency) {
    deleteFromList(state.currencies, currency);
  }, 
  [GET_WORKSPACES] (state:State, workspaces:Workspace[]) {
    state.workspaces = workspaces;
  },
  [BEGIN_UPLOAD] (state:State) {
    state.uploadInProgress = true;
  },
  [END_UPLOAD] (state:State) {
    state.uploadInProgress = false;
  },
  [ERROR] (state:State, msg:string) {
    state.actionError = true;
    state.actionErrorMsg = msg;
  },
  [CLEAR_ERROR] (state:State) {
    state.actionError = false;
    state.actionErrorMsg = "";
  },
  [CREATE_WORKSPACE] (state:State, workspace:Workspace) {
    state.workspaces.push(workspace);
  },
  [GET_CURRENT_WORKSPACE](state:State, workspace:Workspace) {
    //state.currentWorkspace = workspace; 
  },
  [SET_REPO_COLLECTION] (state:State, rp:RepoCollection) {
    state.repoCollection = rp;
  },
  [SET_CURRENT_WORKSPACE](state:State, workspace?:Workspace) {  
    state.currentWorkspace = workspace;
  },
  [GET_TEMPLATE_LIST](state:State, list:Template[]) {
    state.templateList = list;
  },
  [GET_DASHBOARD_WIDGETS](state:State, dashboardWidgets:DashboardWidget[]) {
    state.dashboardWidgets = [...dashboardWidgets];
  },
  [SAVE_DASHBOARD_WIDGET](state:State, dashboardWidget:DashboardWidget) {
    state.dashboardWidgets.push(dashboardWidget);
  },
  [EDIT_DASHBOARD_WIDGET] (state:State, dashboardWidget:DashboardWidget) {
    const dashboardWidgets:DashboardWidget[] = state.dashboardWidgets;
    let index = dashboardWidgets.findIndex(f => f.uuid === dashboardWidget.uuid);
    state.dashboardWidgets.splice(index, 1, dashboardWidget);
  },
  [DELETE_DASHBOARD_WIDGET](state:State, dashboardWidget:DashboardWidget) {
    const dashboardWidgets:DashboardWidget[] = state.dashboardWidgets;
    let index = dashboardWidgets.findIndex(t => t.uuid === dashboardWidget.uuid);
    state.dashboardWidgets.splice(index, 1);
  },
};

function getCurrentRp(state:State) : RepoCollection {
  const rp = state.repoCollection;
  if (!rp) {
    throw new Error("Illegal state");
  }
  return rp;
}

const actions = {
  async clearError({commit}:{commit:any}) {
    commit(CLEAR_ERROR);
  },
  async getTransactions({state, commit}:{state:State, commit:any}) {
    const rp = getCurrentRp(state);
    const txs = rp.getTransactionRepository().getAll();
    commit(GET_TRANSACTIONS, txs);
  },
  async getAccounts({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    const accounts = rp.getAccountRepository().getAll();
    commit(GET_ACCOUNTS, accounts);
  },
  async getCounterparties({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    const counterparties = rp.getCounterpartyRepository().getAll();
    commit(GET_COUNTERPARITES, counterparties);
    commit(GET_DEFAULT_COUNTERPARTY, rp.getCounterpartyRepository().getDefaultCounterparty());
  },
  async getTransactionTypes({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    const transactionTypes = rp.getTransactionTypeRepository().getAll();
    commit(GET_TRANSACTION_TYPES, transactionTypes);
  },
  async getCurrencies({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    const currencies = rp.getCurrencyRepository().getAll();
    commit(GET_CURRENCIES, currencies);
  },
  async getPrimaryCurrency({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    commit(GET_PRIMARY_CURRENCY, rp.getCurrencyRepository().getDefaultCurrency());
  },
  async getDefaultCounterparty({state, commit}:{state:State,commit:any}) {
    const rp = getCurrentRp(state);
    commit(GET_DEFAULT_COUNTERPARTY, rp.getCounterpartyRepository().getDefaultCounterparty());
  },
  async saveTransaction({state, commit}:{state:State,commit:any},
    {transaction, files, blobs}:{transaction:Transaction, files:ExternalFile[], blobs:BlobContent[]}) {
    const rp = getCurrentRp(state);

    if (blobs) {
      const blobPromises = blobs.map(blob => rp.getBlobContentRepository().put(blob.uuid, blob));
      await Promise.all(blobPromises);
    }

    if (files) {
      const filePromises = files.map(file => rp.getExternalFileRepository().put(file.uuid, file));
      await Promise.all(filePromises);
    }

    rp.getTransactionRepository().put(transaction.uuid, transaction);

    commit(SAVE_TRANSACTION, transaction);
  },
  async deleteTransaction({state, commit}:{state:State,commit:any}, transaction:Transaction) {
    const rp = getCurrentRp(state);
    rp.getTransactionRepository().delete(transaction.uuid);
    commit(DELETE_TRANSACTION, transaction);
  },
  async saveAccount({state, commit}:{state:State,commit:any}, account:Account) {
    const rp = getCurrentRp(state);
    rp.getAccountRepository().put(account.uuid, account);
    commit(SAVE_ACCOUNT, account);
  },
  async deleteAccount({state, commit}:{state:State,commit:any}, accountParam:Account[]) : Promise<Reply> {
    const account = accountParam[0];
    const replacementAccount = accountParam[1];
    const rp = getCurrentRp(state);
    if (!rp) {
      return Promise.reject(Reply.with(ReplyCode.UNKNOWN, "IllegalState"));
    }

    if (rp.getAccountRepository().checkIfParent(account)) {
      return Promise.reject(Reply.with(ReplyCode.DELETE_FAILED_CHILD_DEPENDENCY, "Account is a parent account"));
    }

    const txs = rp.getTransactionRepository().findByAccount(account);
    const count = txs.length;
    if (count > 0 && 
          (replacementAccount === undefined 
            || replacementAccount.uuid === account.uuid)) {
      const msg = `${count} Transaction with the account exists, replacement account required`;
      return Promise.reject(Reply.with(ReplyCode.DELETE_FAILED_DATA_DEPENDENCY, msg));
    }

    if (replacementAccount !== undefined && count > 0) {
      const replacedTxs = txs.map(tx => tx.findReplaceAccount(account, replacementAccount))
      rp.getTransactionRepository().putAll(replacedTxs);
    }

    rp.getAccountRepository().delete(account.uuid);
    commit(DELETE_ACCOUNT, account);
    return Promise.resolve(Reply.ok());
  },
  async deleteCounterparty({state, commit}:{state:State,commit:any}, cpParam:Counterparty[]) : Promise<Reply> {
    const cp = cpParam[0];
    const replacementCp = cpParam[1];
    const rp = getCurrentRp(state);
    if (!rp) {
      return Promise.reject(Reply.with(ReplyCode.UNKNOWN, "IllegalState"));
    }

    const txs = rp.getTransactionRepository().findByCounterparty(cp);
    const count = txs.length;
    if (count > 0 && 
          (replacementCp === undefined 
            || replacementCp.uuid === cp.uuid)) {
      const msg = `${count} Transaction with the counterparty exists, replacement counterparty required`;
      return Promise.reject(Reply.with(ReplyCode.DELETE_FAILED_DATA_DEPENDENCY, msg));
    }

    if (replacementCp !== undefined && count > 0) {
      const replacedTxs = txs.map(tx => tx.findReplaceCounterparty(cp, replacementCp))
      rp.getTransactionRepository().putAll(replacedTxs);
    }

    rp.getCounterpartyRepository().delete(cp.uuid);
    commit(DELETE_COUNTERPARTY, cp);
    return Promise.resolve(Reply.ok());
  },
  async deleteCurrency({state, commit}:{state:State,commit:any}, currency:Currency) : Promise<Reply> {
    const rp = getCurrentRp(state);
    if (!rp) {
      return Promise.reject(Reply.with(ReplyCode.UNKNOWN, "IllegalState"));
    }

    const txWithCurrencyExists = rp.getTransactionRepository().hasTransactionWithCurrency(currency);
    if (txWithCurrencyExists) {
      const msg = `Transaction with the currency '${currency.symbol}' exists`;
      return Promise.reject(Reply.with(ReplyCode.DELETE_FAILED_IMMUTABLE_DEPENDENCY, msg));
    }

    rp.getCurrencyRepository().delete(currency.uuid);
    commit(DELETE_CURRENCY, currency);
    return Promise.resolve(Reply.ok());
  },
  async saveTransactionType({state, commit}:{state:State,commit:any}, transactionType:TransactionType) {
    const rp = getCurrentRp(state);
    rp.getTransactionTypeRepository().put(transactionType.uuid, transactionType);
    commit(SAVE_TRANSACTION_TYPE, transactionType);
  },
  async deleteTransactionType({state, commit}:{state:State,commit:any}, transactionType:TransactionType) : Promise<Reply> {
    const rp = getCurrentRp(state);
    if (!rp || !transactionType) {
      return Promise.reject(Reply.with(ReplyCode.UNKNOWN, "IllegalState"));
    }
    rp.getTransactionTypeRepository().delete(transactionType.uuid);
    commit(DELETE_TRANSACTION_TYPE, transactionType);
    return Promise.resolve(Reply.ok());

  },
  async saveCurrency({state, commit}:{state:State,commit:any}, currency:Currency) {
    const rp = getCurrentRp(state);
    rp.getCurrencyRepository().put(currency.uuid, currency)
    commit(SAVE_CURRENCY, currency);
  },
  async saveCounterparty({state, commit}:{state:State,commit:any}, counterparty:Counterparty) : Promise<Reply> {
    const rp = getCurrentRp(state);
    if (!rp) {
      return Promise.reject(Reply.with(ReplyCode.UNKNOWN, "IllegalState"));
    }
    const counterpartyRepo = rp.getCounterpartyRepository();

    const isUnique = counterpartyRepo.checkUniqueString(cp => cp.name, counterparty.name);
    if (!isUnique) {
      return Promise.reject(Reply.with(ReplyCode.UNIQUE_FIELD_CONSTRAINT, "Counterparty with this name already exists."));
    }
    
    Context.getInstance().triggerCacheRefresh(counterparty.uuid);
    counterpartyRepo.put(counterparty.uuid, counterparty)
    commit(SAVE_COUNTERPARTY, counterparty);
    return Promise.resolve(Reply.ok());
  }, 
  async getWorkspaces({state, commit}:{state:State,commit:any}) {
    const wss = await Workspaces.getInstance().getAll();
    const current = await Workspaces.getInstance().getCurrent();
    if (current) {
      await actions.setCurrentWorkspace({commit}, current);
    }
    commit(GET_WORKSPACES, wss);
  },
  async getCurrentWorkspace({commit}:{commit:any}) {
    const current = await Workspaces.getInstance().getCurrent();
    commit(GET_CURRENT_WORKSPACE, current);
  },
  async createWorkspace({commit}:{commit:any}, wsProps:any) {
    const ws = await Workspaces.getInstance().createNew({name: wsProps.name, type:wsProps.type, uuid:uuid()});
    const currency = new Currency(uuid(), wsProps.currency, true);

    const template:Template = wsProps.template;
    let accounts:Account[] = [];
    let transactionTypes:TransactionType[] = [];
    if (template) {
      accounts = template.createAccounts();
      transactionTypes = (template.createTransactionTypes());
    }

    const accountRepo = (await ws.getRepoCollection()).getAccountRepository();
    const transactionTypeRepo = (await ws.getRepoCollection()).getTransactionTypeRepository();
    for (let index = 0; index < accounts.length; index++) {
      const account = accounts[index];
      await accountRepo.put(account.uuid, account);
    }
    for (let index = 0; index < transactionTypes.length; index++) {
      const transactionType = transactionTypes[index];
      await transactionTypeRepo.put(transactionType.uuid, transactionType);
    }

    const currencyRepo = (await ws.getRepoCollection()).getCurrencyRepository();
    await currencyRepo.put(currency.uuid, currency);
    commit(CREATE_WORKSPACE, ws);
  },
  async deleteWorkspace({commit}:{commit:any}, workspace:Workspace) {
    await Workspaces.getInstance().delete(workspace);
    const wss = await Workspaces.getInstance().getAll();
    commit(GET_WORKSPACES, wss);
  },
  async renameWorkspace({commit}:{commit:any}, wjson:WorkspaceJson) {
    await Workspaces.getInstance().rename(wjson);
    const wss = await Workspaces.getInstance().getAll();
    commit(GET_WORKSPACES, wss);
  },
  async getTemplateList({commit}:{commit:any}) {
    commit(GET_TEMPLATE_LIST, templateList);
  },
  async logoutWorkspace({state,commit}:{state:State, commit:any}) {
    const current = state.currentWorkspace;
    if (current) {
      current.clear();
    }
    await Workspaces.getInstance().clearCurrent();
    commit(SET_CURRENT_WORKSPACE, undefined);
  },
  async setCurrentWorkspace({commit}:{commit:any}, workspace:Workspace) {
    const rp = await workspace.getRepoCollection();
    
    const accounts = rp.getAccountRepository().getAll();
    const cps = rp.getCounterpartyRepository().getAll();
    const transactionTypes = rp.getTransactionTypeRepository().getAll();
    const currencies = rp.getCurrencyRepository().getAll();

    await Workspaces.getInstance().setCurrent(workspace.uuid);

    commit(GET_ACCOUNTS, accounts);
    commit(GET_COUNTERPARITES, cps);
    commit(GET_DEFAULT_COUNTERPARTY, rp.getCounterpartyRepository().getDefaultCounterparty());
    commit(GET_TRANSACTION_TYPES, transactionTypes);
    commit(GET_CURRENCIES, currencies);
    commit(GET_PRIMARY_CURRENCY, rp.getCurrencyRepository().getDefaultCurrency());
    commit(GET_CONFIGURATIONS, rp.getConfigurations());

    commit(SET_REPO_COLLECTION, rp);
    commit(SET_CURRENT_WORKSPACE, workspace);
  },
  async downloadWorkspace({commit}:{commit:any},workspace:Workspace) {
    const workspaceJson = await workspace.downloadContent();
    var blob = new Blob([JSON.stringify(workspaceJson)], {type: "application/json;charset=utf-8"});
    saveAs(blob, workspace.name);
  },
  async importWorkspace({commit}:{commit:any}, wjson:WorkspaceContentJson) {
    await Workspaces.getInstance().importFromJson(wjson);
    const wss = await Workspaces.getInstance().getAll();
    commit(GET_WORKSPACES, wss);
  },
  async getDashboardWidgets({state, commit}:{state:State, commit:any}) {
    const rp = getCurrentRp(state);
    const dashboardWidgets = rp.getDashboardWidgetRepository().getAll();
    commit(GET_DASHBOARD_WIDGETS, dashboardWidgets);
  },
  async saveDashboardWidget({state, commit}:{state:State, commit:any}, dashboardWidget:DashboardWidget) {
    const rp = getCurrentRp(state);
    await rp.getDashboardWidgetRepository().put(dashboardWidget.uuid, dashboardWidget);
    commit(SAVE_DASHBOARD_WIDGET, dashboardWidget);
  },
  async saveDashboardWidgets({state, commit}:{state:State, commit:any}, dashboardWidgets:DashboardWidget[]) {
    const rp = getCurrentRp(state);
    for(const dashboardWidget of dashboardWidgets) {
      await rp.getDashboardWidgetRepository().put(dashboardWidget.uuid, dashboardWidget);
    }
    commit(GET_DASHBOARD_WIDGETS, rp.getDashboardWidgetRepository().getAll());
  },
  async editDashboardWidget({state, commit}:{state:State,commit:any}, dashboardWidget:DashboardWidget) {
    const rp = getCurrentRp(state);
    await rp.getDashboardWidgetRepository().put(dashboardWidget.uuid, dashboardWidget);
    commit(EDIT_DASHBOARD_WIDGET, dashboardWidget);
  },
  async deleteDashboardWidget({state, commit}:{state:State, commit:any}, dashboardWidget:DashboardWidget) {
    const rp = getCurrentRp(state);
    await rp.getDashboardWidgetRepository().delete(dashboardWidget.uuid);
    commit(DELETE_DASHBOARD_WIDGET, dashboardWidget);
  },
  async saveEntityContainer({state, commit}:{state:State,commit:any}, container:EntityContainer) {
    const rp = getCurrentRp(state);
    const accountRepo = rp.getAccountRepository();
    const counterpartyRepo = rp.getCounterpartyRepository();
    const transactionRepo = rp.getTransactionRepository();
    
    const accPromises = container.accounts.map(obj => accountRepo.put(obj.uuid, obj));
    await Promise.all(accPromises);
    const cpPromises = container.counterparties.map(obj => counterpartyRepo.put(obj.uuid, obj));
    await Promise.all(cpPromises);
    const txPromises = container.transactions.map(obj => transactionRepo.put(obj.uuid, obj));
    await Promise.all(txPromises);
    commit(GET_TRANSACTIONS, transactionRepo.getAll());
    commit(GET_ACCOUNTS, accountRepo.getAll());
    commit(GET_COUNTERPARITES, counterpartyRepo.getAll())
  }
};

function isBetweenDatesFunc(dates:Date[]) {
  const begin = dates.length === 0 ? undefined : dates.map(d => d.valueOf()).reduce((d1, d2) => d1 < d2 ? d1 : d2)
  const end = dates.length < 2 ? undefined : dates.map(d => d.valueOf()).reduce((d1, d2) => d1 > d2 ? d1 : d2)
  return (date:Date) => {
    const epoch = date.valueOf();
    if (begin && end) {
      return epoch >= begin && epoch <= end;
    }
    else if (begin) {
      return epoch >= begin;
    }
    else if (end) {
      return epoch <= end;
    }
    
    return true;
  }  
}

const getters = {
  findCurrency: (state:State) => (symbol:string) => {
    const currencies = state.currencies;
    const filtered = currencies
      .filter(cur => cur.symbol === symbol);
    return filtered.length > 0 ? filtered[0] : undefined;
  },
  getTransactions: (state:State)=> (counterpartyKeywords:string="",dates:Date[]=[]) => {
    const txs = state.transactions;
    if (!counterpartyKeywords && dates.length === 0) {
      return txs;
    }
    const datesFunc = isBetweenDatesFunc(dates);
    const keywordsLwr = counterpartyKeywords.toLowerCase();
    return txs.filter(
      (tx) => tx.counterparty.obj().name.toLowerCase().indexOf(keywordsLwr) >= 0 && datesFunc(tx.date)
    );
  },
  getBalanceSheet: (state:State) => (dates:Date[]=[]) => {
    const isBetweenDates = isBetweenDatesFunc(dates);
    const transactions = state.transactions.filter(tx => isBetweenDates(tx.date));
    return BalanceSheet.from(transactions);
  },
  filterRegisterEntries: (state:State) => (account?:Account, counterparty?:Counterparty, dates:Date[]=[]) => {
    
    let accountRefs:string[] = [];
    if (account) {
      accountRefs = Account.getChildrenRefs(state.accounts, account);
      accountRefs.push(account.uuid);
    }
    const isOneOfAccounts = (ref:Ref<Account>) => {
      return account ? accountRefs.find(uuid => uuid === ref.uuid) : true;
    }
    const isCounterparty = (ref:Ref<Counterparty>) => {
      return counterparty ? counterparty.uuid === ref.uuid : true;
    }

    const isBetweenDates = isBetweenDatesFunc(dates);

    const registerEntries = Register.registerEntries(state.transactions);

    const filteredEntries = registerEntries
      .filter(entry => {
        return isCounterparty(entry.counterparty) && isOneOfAccounts(entry.account) && isBetweenDates(entry.date);
      });

    const totalAmount = filteredEntries.length > 0 ? filteredEntries.map(ent => ent.amount).reduce((a1,a2) => a1.add(a2)) : undefined;
    
    return {
      entries: filteredEntries,
      length : filteredEntries.length,
      totalAmount: totalAmount,
    }
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
